export default "__VITE_ASSET__Dzy$iGlz__"